<template>
  <div
    class="pavilion_map"
    id="pavilion_map"
    :style="{ height: height + 'px', width: width + 'px' }">
    <client-only>
      <!-- 百度地图 -->
      <baidu-map
        class="bm-view"
        :center="centerFormat(detail)"
        :style="{ height: height + 'px' }"
        :zoom="15"
        v="2.0"
        @ready="baiduMapReady">
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
        <bm-marker
          :position="position"
          animation="BMAP_ANIMATION_BOUNCE"
          @click="infoWindowToggle" />
        <bm-info-window
          :show="showInfoWindow"
          :position="position"
          :title="$get(detail, 'pavilionName') || $get(detail, 'pavilionEnglishName', '')"
          :offset="{ height: -20 }">
          <p>
            {{ $get(detail, 'pavilionAddress') || $get(detail, 'pavilionEnglishAddress', '') }}
          </p>
        </bm-info-window>
      </baidu-map>
    </client-only>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, onMounted, ref } from 'vue'
  import _ from 'lodash'
  // @ts-ignore
  import { BmInfoWindow, BmMarker, BmNavigation } from 'vue-baidu-map-3x'

  const props = defineProps({
    detail: {
      type: Object,
      default: null
    },
    center: {
      type: Array
    },
    attribution: {
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 295
    },
    width: {
      type: Number,
      default: 795
    }
  })

  const mapRef = ref(null)
  const showInfoWindow = ref(true)
  const position = ref({})

  // 百度地图加载完成后的回调函数
  const baiduMapReady = ({ BMap, map }: Record<string, any>) => {
    // console.log('Baidu Map is ready', BMap, map);
    mapRef.value = map
    setTimeout(() => {
      position.value = map.getCenter()
    }, 800)
  }

  // 切换信息窗口的显示状态
  const infoWindowToggle = () => {
    showInfoWindow.value = !showInfoWindow.value
  }

  // 格式化中心点坐标
  const centerFormat = (item: Record<string, any>) => {
    const lng = _.get(item, 'longitude', '')
    const lat = _.get(item, 'latitude', '')
    const pavilionName = _.get(item, 'pavilionName', '')
    if (lng && lat) {
      return { lat, lng }
    } else {
      return pavilionName
    }
  }

  const $get = _.get<any, string>

  onMounted(() => {
    // console.log('Map component mounted', props);
  })
</script>

<style lang="less" scoped>
  .pavilion_map {
    width: 795px;
    height: 297px;
    border-radius: 6px;
    overflow: hidden;

    .bm-view {
      width: 100%;
      height: 297px;
    }
  }
</style>
